import React, { useState } from 'react'
import axios from "axios";
import { useNavigate } from 'react-router-dom';

import { Button, Input } from '../../components/DesignSystem'

import logoVibraSvg from "../../assets/logo-vibra.svg";
import logoVibraPng from "../../assets/logo-vibra.png";

import "./index.scss";

export default function ResendCode() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitMessage, setSubmitMessage] = useState("");

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  function handleGoToFirstAccess() {
    navigate("/primeiro-acesso");
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (submitMessage) setSubmitMessage("")
    try {
      setIsLoadingSubmit(true)
      await axios.put('/auth/resend-verification-code', { email })
    } catch (error) {
    } finally {
      setEmail("")
      setSubmitMessage('Caso haja uma proposta para você, um novo código será enviado para seu e-mail.')
      setIsLoadingSubmit(false)
    }
  }

  return (
    <div className="resend-code">
      <section>
        <header>
          <div className="resend-code__logo">
            <picture>
              <source type="image/svg+xml" srcSet={logoVibraSvg} />
              <img src={logoVibraPng} alt="Vibra" />
            </picture>
          </div>
        </header>
        <form
          className="resend-code__form"
          onSubmit={handleSubmit}
        >
          <div className="resend-code__form__header">
            <h3>Reenviar código por email</h3>
            <p>Por favor, preencha os campos abaixo</p>
          </div>
          <div className="resend-code__form__main">
            <Input
              label="Email"
              placeholder=""
              type="email"
              value={email}
              onChange={setEmail}
              required
            />
            <Button
              type="submit"
              contained
              disabled={isLoadingSubmit}
              loading={isLoadingSubmit}
              style={{ width: "100%" }}
            >
              Continuar
            </Button>
            <div
              className={
                submitMessage
                  ? "resend-code__form__message resend-code__form__message--visible"
                  : "resend-code__form__message"
              }
              dangerouslySetInnerHTML={{ __html: submitMessage }}
            />
          </div>
          <div className="resend-code__form__footer">
            <p>Já possui um código?</p>
            <button type="button" onClick={handleGoToFirstAccess}>
              Faça login
            </button>
          </div>
        </form>
      </section>
      <div className="resend-code__image">
        {/* NASDAQ 2025
        <span role="img" aria-label="rocket">🚀</span> */}
      </div>
    </div>
  )
}
